var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4779 16.0765C18.4739 16.727 17.9658 17.3457 17.2135 17.3457H2.09562C1.34409 17.3457 0.835594 16.727 0.832049 16.0765C0.830328 15.7561 0.951869 15.4475 1.17118 15.2154C1.93216 14.392 3.35603 13.1529 3.35603 9.0957C3.35603 6.01385 5.50189 3.54678 8.39534 2.94152V2.11493C8.39534 1.77831 8.52813 1.45548 8.7645 1.21745C9.00088 0.979425 9.32147 0.845703 9.65575 0.845703C9.99004 0.845703 10.3106 0.979425 10.547 1.21745C10.7834 1.45548 10.9162 1.77831 10.9162 2.11493V2.94152C13.8073 3.54678 15.9531 6.01385 15.9531 9.0957C15.9531 13.1533 17.377 14.392 18.138 15.2154C18.3575 15.4474 18.4793 15.756 18.4779 16.0765Z",
    fill: "#335C75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13281 18.6152H12.1745C12.1745 19.2885 11.9089 19.9341 11.4361 20.4102C10.9634 20.8863 10.3222 21.1537 9.65365 21.1537C8.98508 21.1537 8.3439 20.8863 7.87115 20.4102C7.3984 19.9341 7.13281 19.2885 7.13281 18.6152Z",
    fill: "#335C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerBell);
export default __webpack_public_path__ + "static/media/DrawerBell.2605f2e7e6e5087ec4782c6019e8c51f.svg";
export { ForwardRef as ReactComponent };